import styled from 'styled-components';

export const AvatarWrapper = styled.div`
  display: flex;
  align-items: center;
  column-gap: 7px;
  cursor: pointer;

  .user-info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    row-gap: 4px;

    span {
      line-height: 1;
    }

    .user-name {
      font-size: 15px;
      color: #333;
    }

    .user-role {
      font-size: 13px;
      color: #9e9e9e;
    }
  }
`;
